enum Event {
  onAbort = 'onAbort',
  onAfterFetch = 'onAfterFetch',
  onBeforeClose = 'onBeforeClose',
  onBeforeFetch = 'onBeforeFetch',
  onBlur = 'onBlur',
  onCancel = 'onCancel',
  onChange = 'onChange',
  onClick = 'onClick',
  onClose = 'onClose',
  onCollapse = 'onCollapse',
  onContextMenuClick = 'onContextMenuClick',
  onDoubleClick = 'onDoubleClick',
  onDynamicContentRender = 'onDynamicContentRender',
  onEdit = 'onEdit',
  onFocus = 'onFocus',
  onKeyDown = 'onKeyDown',
  onKeyPress = 'onKeyPress',
  onKeyUp = 'onKeyUp',
  onMount = 'onMount',
  onNavigate = 'onNavigate',
  onNextPage = 'onNextPage',
  onPrevPage = 'onPrevPage',
  onRender = 'onRender',
  onSelect = 'onSelect',
  onSort = 'onSort',
  onSubmit = 'onSubmit',
  onUnmount = 'onUnmount',

}

export default Event;
